export default "__VITE_ASSET__BHBEDugo__"